import request from "../utils/request";

export const list = (data) => request.get("/api/export", data);
export const exportIncome = () => request.post("/api/income/export");
export const userExport = (data) => request.post("/api/app_user/export", data);
